import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { NationBadge } from "@/components/Compliance";
import { Radar, X, ExternalLink, ListPlus } from "lucide-react";

export default function LawRadar() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/lawupdates").then((r) => setItems(r.data.filter((i) => !i.dismissed))).catch(() => {});
  useEffect(() => { load(); }, []);
  const dismiss = async (id) => { await api.post(`/lawupdates/${id}/dismiss`); load(); };
  if (items.length === 0) return null;
  return (
    <div className="mt-8" data-testid="law-radar">
      <h2 className="font-heading text-xl font-bold flex items-center gap-2"><Radar size={20} className="text-sky-600" /> Law change radar</h2>
      <p className="text-xs text-muted-foreground mt-1">Changes affecting your nations. Verify against the official source before acting.</p>
      <div className="mt-3 grid md:grid-cols-2 gap-3">
        {items.slice(0, 6).map((i) => (
          <div key={i.id} data-testid={`radar-${i.id}`} className="bg-card border border-border rounded-2xl p-4 relative">
            <button data-testid={`radar-dismiss-${i.id}`} onClick={() => dismiss(i.id)} aria-label="Dismiss" className="absolute top-3 right-3 p-1 rounded-md text-muted-foreground hover:bg-secondary"><X size={14} /></button>
            <div className="flex items-center gap-2 flex-wrap pr-6"><NationBadge nation={i.nation} />{i.effective_date && <span className="text-[10px] px-1.5 py-0.5 rounded bg-sky-100 text-sky-800">from {i.effective_date}</span>}{i.rule && <span className="text-[10px] px-1.5 py-0.5 rounded bg-emerald-100 text-emerald-800 inline-flex items-center gap-1"><ListPlus size={10} /> checklist item added</span>}</div>
            <p className="font-semibold text-sm mt-2">{i.title}</p>
            <p className="text-xs text-muted-foreground mt-1 leading-relaxed">{i.body}</p>
            {i.rule && <p className="text-xs mt-2 text-emerald-deep font-medium">New on every {i.nation} checklist: {i.rule.name}</p>}
            {i.source_link && <a href={i.source_link} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-xs text-emerald-brand mt-2 hover:underline">Official source <ExternalLink size={11} /></a>}
          </div>
        ))}
      </div>
    </div>
  );
}
